import { contextoMinhaVisualizacao, aplicarMinhaVisualizacao } from "./prontuario-layout";

// Mesmos escopos, campos e padrões da abertura legada; uma entrada por preferência.
const catalogo = [
  ["4","ATENDIMENTO","TITULO_PASTA_ATENDIMENTO","CONTEUDO","Queixa"],
  ["2","ATENDIMENTO","MOTIVO_RE_ESPERA","TEXTO",""],
  ["4","ATENDIMENTO","REPETE_ULT_ATEND","CONTEUDO","0"],
  ["2","FATURAMENTO","CATEGORIA_CONSULTA","CONTEUDO","0"],
  ["4","ATENDIMENTO","INFO_AT_OBRIG_OU_PEND","CONTEUDO",""],
  ["4","ATENDIMENTO","OBRIG_CID_ATENDIMENTO","CONTEUDO",""],
  ["4","ATENDIMENTO","OBRIG_DADOS_ATENDIMENTO","CONTEUDO",""],
  ["4","ATENDIMENTO","OBRIG_RETORNO","CONTEUDO",""],
  ["4","ATENDIMENTO","OBRIG_RETORNO_CONSULTA","CONTEUDO",""],
  ["4","ATENDIMENTO","OBRIG_LAUDO","CONTEUDO",""],
  ["4","ATENDIMENTO","INCLUI_ATENDIMENTO_SEM_AGENDA","CONTEUDO",""],
  ["1","ATENDIMENTO","ATENDIMENTO_BACKGROUND","TEXTO",""],
  ["4","ATENDIMENTO","BOTOES_SOMENTE_ICONES_INCLUSAO","CONTEUDO",""],
  ["4","ATENDIMENTO","TIMELINE_PEP_ENTRA_AGRUPADA","CONTEUDO",""],
  ["4","ATENDIMENTO","PERMITE_REALIZAR_AUDITORIA_PEP","CONTEUDO",""],
  ["4","ATENDIMENTO","HABILITAR_RESUMO_IA_PEP","CONTEUDO","0"],
  ["4","ATENDIMENTO","USUARIO_MEMBRO_ONA","CONTEUDO",""],
  ["4","ATENDIMENTO","TEXTO_RECEITUARIO","CONTEUDO",""],
  ["4","ATENDIMENTO","TEXTO_RECEITUARIO_ESPECIAL","CONTEUDO",""],
  ["4","ATENDIMENTO","TEXTO_SOLICITACAO_EXAMES","CONTEUDO",""],
  ["4","PEP","MENU_MINHA_VISUALIZACAO","TEXTO",""],
  ["4","PEP","BOTOES_INCLUSAO_PEP","TEXTO",""],
  ["2","ATENDIMENTO","PEP_LAUDO_STATUS_REVISADO","CONTEUDO",""],
  ["4","ATENDIMENTO","SISTEMAS_ATENDIMENTO","TEXTO",""],
  ["2","ATENDIMENTO","ALTURA_TELA_ATENDIMENTO","CONTEUDO","475"],
  ["4","ATENDIMENTO","NOME_FONTE_ATENDIMENTO","CONTEUDO","Tahoma"],
  ["4","ATENDIMENTO","TAMANHO_FONTE_ATENDIMENTO","CONTEUDO","11"],
  ["2","ATENDIMENTO","SINAL_RESUL_CAMPO_CALC","CONTEUDO","0"],
  ["2","ATENDIMENTO","RESPEITA_MASCARA_ATENDIEMTNO","CONTEUDO","0"],
  ["2","ATENDIMENTO","CAMPOS_FICHA_MASCARA_INTEIRO","CONTEUDO","0"],
  ["2","ATENDIMENTO","CAMPOS_FICHA_MASCARA_SINALAMPLO","CONTEUDO","0"],
  ["2","ATENDIMENTO","MOTIVOS_RETORNO","TEXTO","\n          Rotina\r\n\n          Óculos\r\n\n          Olho seco\r\n\n          Lente de contato\r\n\n          Retina\r\n\n          Catarata sem indic cirurgica\r\n\n          Glaucoma\n        "],
  ["2","AGENDA_RETORNO","TIPO_RETORNO","TEXTO","\n          Não Atendido\r\n\n          Ligar mais tarde\r\n\n          Não quis Retornar\r\n\n          Marcado\r\n\n          Email Enviado   \n        "],
  ["2","ATENDIMENTO","ASSINATURA_APOS_FINALIZAR","CONTEUDO",""],
  ["2","ATENDIMENTO","SO_ATEND_PACIENTE_ATUALIZADO","CONTEUDO",""],
  ["2","ATENDIMENTO","SOLICITAR_PROCEDIM_NOVAESPERA","CONTEUDO",""],
  ["4","ATENDIMENTO","BOTOES_MONOCOLOR_INCLUSAO","CONTEUDO",""],
  ["2","AGENDA","FILTRA_PROCED_QTEM_PRC_SOLIC","CONTEUDO","0"],
  ["4","LAUDO","LAUDO_LIBERACAO_MODO","CONTEUDO",""],
  ["4","LAUDO","MARCA_OPCOES_REVISAR_ASSINAR","CONTEUDO",""],
  ["4","ATENDIMENTO","COLAPSAR_AGRUPAMENTOS_TEXTOS","CONTEUDO",""],
  ["4","ATENDIMENTO","PERMANECE_PEP_NOVA_ESPERA","CONTEUDO",""],
  ["2","ATENDIMENTO","NAO_DESMARCA_PROCEDIMENTOS_PEP","CONTEUDO",""],
  ["4","ATENDIMENTO","INVERTE_CLIQUE_ABRIR_IMAGEM","CONTEUDO",""],
  ["4","ATENDIMENTO","PRODUTO_ATENDIMENTO_SEM_AGENDA","CONTEUDO",""],
  ["4","ATENDIMENTO","PERMITE_ATENDER_SEM_CHEGADA","CONTEUDO",""]
];

export function pedidosConfiguracoesProntuario(usuario) {
  return catalogo.map(([NIVEL, MODULO, CAMPO, CONTEUDO_NOME, CONTEUDO]) => ({
    NIVEL, MODULO, CAMPO, CONTEUDO_NOME, CONTEUDO, USUARIO: NIVEL === "4" ? String(usuario || "").trim() : "GERAL", SISTEMA: "CLMADV", OPERACAO: "C"
  }));
}

const objeto = value => value !== null && typeof value === "object" && !Array.isArray(value);
const chave = row => JSON.stringify([row.NIVEL, row.USUARIO, row.SISTEMA, row.MODULO, row.CAMPO].map(v => String(v ?? "").trim()));
const escalar = value => value == null ? "" : typeof value === "boolean" ? (value ? "1" : "0") : String(value);

export async function consultarConfiguracoesProntuario(api, jwt, { fonte, configuracoes, signal }) {
  if(!["master", "usuario"].includes(fonte) || !jwt.getToken()) { throw new Error("Sessão ou consulta indisponível."); }
  api.setHeader();
  const options = { signal, timeout: 120000 };
  if(fonte === "usuario") {
    const { data } = await api.query("configuracoes/access/buscarConfiguracoesGeraisUsuario", options);
    return data;
  }
  const { data } = await api.postOnce("configuracoes/access/lerConfiguracoesProntuario", configuracoes, options);
  if(data?.contrato !== "CONFIGURACOES_PEP_V1" || data.resultado !== true) { throw new Error("Leitura não confirmada."); }
  return data.configuracoes;
}

function validarLinhas(rows) {
  if(!Array.isArray(rows)) { throw new Error("Resposta inválida das configurações."); }
  return rows.map(row => {
    if(!objeto(row) || typeof row.CAMPO !== "string" || !row.CAMPO.trim() ||
      [row.CONTEUDO, row.TEXTO].some(v => v != null && !["string", "number", "boolean"].includes(typeof v))) {
      throw new Error("Configuração inválida.");
    }
    return { ...row, CAMPO: row.CAMPO.trim(), CONTEUDO: escalar(row.CONTEUDO), TEXTO: escalar(row.TEXTO) };
  });
}

export function prepararConfiguracoesProntuario(master, usuario, pedidos) {
  const esperadas = new Map(pedidos.map(row => [chave(row), row]));
  const recebidas = new Map();
  for(const [index, row] of validarLinhas(master).entries()) {
    const key = chave(row);
    if(!esperadas.has(key) || recebidas.has(key)) { throw new Error("Configuração divergente ou duplicada."); }
    const original = master[index];
    if(!Object.prototype.hasOwnProperty.call(original, esperadas.get(key).CONTEUDO_NOME)) { throw new Error("Conteúdo ausente."); }
    recebidas.set(key, { ...row, MODULO: row.MODULO.trim() });
  }
  if(recebidas.size !== esperadas.size) { throw new Error("Configurações incompletas."); }
  const gerais = validarLinhas(usuario), vistos = new Set();
  for(const [index, row] of gerais.entries()) {
    if(vistos.has(row.CAMPO) || !Object.prototype.hasOwnProperty.call(usuario[index], "CONTEUDO")) { throw new Error("Configuração de usuário inválida."); }
    vistos.add(row.CAMPO);
  }
  // Validar conteúdo usado pelos consumidores antes de qualquer alteração na tela.
  const sistemas = [...recebidas.values()].find(row => row.CAMPO === "SISTEMAS_ATENDIMENTO");
  if(sistemas?.TEXTO) {
    const value = JSON.parse(decodeURIComponent(Array.from(atob(sistemas.TEXTO), c => "%" + c.charCodeAt(0).toString(16).padStart(2, "0")).join("")));
    if(!Array.isArray(value) || value.some(item => !objeto(item) || !["string", "number"].includes(typeof item.value))) { throw new Error("Áreas de atendimento inválidas."); }
  }
  return { master: pedidos.map(row => recebidas.get(chave(row))), usuario: gerais };
}

const camposPagina = {
  TITULO_PASTA_ATENDIMENTO: ["tituloPastaAtendimento", "Queixa"], REPETE_ULT_ATEND: ["copiaAtendimento", "0"],
  INFO_AT_OBRIG_OU_PEND: ["obrigPendAtendimento", "0"], OBRIG_CID_ATENDIMENTO: ["obrigCidAtendimento", "0"],
  OBRIG_DADOS_ATENDIMENTO: ["obrigDadosAtendimento", "0"], OBRIG_RETORNO: ["obrigRetornoAtendimento", "0"],
  OBRIG_RETORNO_CONSULTA: ["obrigRetornoConsultaAtendimento", "0"], OBRIG_LAUDO: ["obrigLaudoAtendimento", "0"],
  TEXTO_RECEITUARIO: ["textoReceituario", ""], TEXTO_RECEITUARIO_ESPECIAL: ["textoReceituarioEspecial", ""],
  TEXTO_SOLICITACAO_EXAMES: ["textoSolicitacaoProcedimento", ""], ASSINATURA_APOS_FINALIZAR: ["assinaturaAposFinalizar", ""],
  SO_ATEND_PACIENTE_ATUALIZADO: ["soAtendPacienteAtualizado", "0"], SOLICITAR_PROCEDIM_NOVAESPERA: ["solicitarProcedimentoNovaEspera", "0"],
  PERMANECE_PEP_NOVA_ESPERA: ["permanecePEPNovaEspera", "0"], NAO_DESMARCA_PROCEDIMENTOS_PEP: ["naoDesmarcaProcedimentosPEP", "0"],
  INVERTE_CLIQUE_ABRIR_IMAGEM: ["inverteCliqueAbrirImagem", "0"], PRODUTO_ATENDIMENTO_SEM_AGENDA: ["produtoAtendimentoSemAgenda", "0"],
  PERMITE_ATENDER_SEM_CHEGADA: ["permiteAtenderSemChegada", "0"]
};
const booleanos = {
  HABILITAR_RESUMO_IA_PEP: "resumoIAHabilitado",
  INCLUI_ATENDIMENTO_SEM_AGENDA: "incluiAtendimentoSemAgenda", BOTOES_SOMENTE_ICONES_INCLUSAO: "botoesSomenteIconeInclusao",
  TIMELINE_PEP_ENTRA_AGRUPADA: "timelinePEPEntraAgrupada", PERMITE_REALIZAR_AUDITORIA_PEP: "permiteRealizarAuditoriaPEP", USUARIO_MEMBRO_ONA: "membroONA"
};
const metodosFicha = {
  ALTURA_TELA_ATENDIMENTO: "inserirConfiguracaoAlturaTelaAtendimento", NOME_FONTE_ATENDIMENTO: "inserirConfiguracaoNomeFonteAtendimento",
  TAMANHO_FONTE_ATENDIMENTO: "inserirConfiguracaoTamanhoFonteAtendimento", SINAL_RESUL_CAMPO_CALC: "inserirConfiguracaoSinalResulCampoCalc",
  RESPEITA_MASCARA_ATENDIEMTNO: "inserirConfiguracaoRespeitaMascaraAtendimento", CAMPOS_FICHA_MASCARA_INTEIRO: "inserirConfiguracaoCamposFichaMascaraInteiro",
  CAMPOS_FICHA_MASCARA_SINALAMPLO: "inserirConfiguracaoCamposFichaMascaraSinalAmplo"
};

export function aplicarConfiguracoesProntuario(vm, snapshot, revisoes) {
  const patch = {}, efeitos = [];
  const emitir = (evento, row) => efeitos.push(() => vm.emitter.emit(evento, row));
  const chamar = (ref, metodo, valor) => {
    const component = vm.$refs[ref];
    if(typeof component?.[metodo] !== "function") { throw new Error("Componente de configuração indisponível."); }
    efeitos.push(() => component[metodo](valor));
  };
  for(const row of snapshot.master) {
    const { MODULO, CAMPO, CONTEUDO, TEXTO } = row;
    if(MODULO === "ATENDIMENTO") {
      if(camposPagina[CAMPO]) { const [campo, padrao] = camposPagina[CAMPO]; patch[campo] = CONTEUDO || padrao; }
      else if(booleanos[CAMPO]) {
        patch[booleanos[CAMPO]] = CONTEUDO === "1";
        if(CAMPO === "TIMELINE_PEP_ENTRA_AGRUPADA" && CONTEUDO === "1") { patch.quantidadeDatasExibindo = 30; }
      } else if(metodosFicha[CAMPO] && CONTEUDO) { chamar("atendimentoInclusao", metodosFicha[CAMPO], CONTEUDO); }
      else if(CAMPO === "MOTIVO_RE_ESPERA" && TEXTO) { patch.motivosReEspera = TEXTO.trim().split("\r\n"); }
      else if(CAMPO === "ATENDIMENTO_BACKGROUND" && TEXTO) { patch.backgroundAtendimento = TEXTO; }
      else if(CAMPO === "PEP_LAUDO_STATUS_REVISADO" && CONTEUDO) { chamar("atendimentoItemLateral", "inserirConfiguracaoStatusRevisado", CONTEUDO); }
      else if(CAMPO === "BOTOES_MONOCOLOR_INCLUSAO") {
        const component = vm.$refs.atendimentoInclusao;
        if(!component) { throw new Error("Editor indisponível."); }
        efeitos.push(() => { component.botoesMonocolor = CONTEUDO === "1"; });
      } else if(CAMPO === "SISTEMAS_ATENDIMENTO" && TEXTO) { emitir("atendimentoAreaCarregarSistemas", row); }
      else if(CAMPO === "MOTIVOS_RETORNO" && TEXTO) { emitir("agendaRetornoDetalheMotivos", row); }
      else if(CAMPO === "COLAPSAR_AGRUPAMENTOS_TEXTOS") { emitir("colapsarAgrupamentosTextos", row); }
    } else if(MODULO === "FATURAMENTO" && CAMPO === "CATEGORIA_CONSULTA") { patch.categoriaConsulta = CONTEUDO || "0"; }
    else if(MODULO === "PEP" && CAMPO === "MENU_MINHA_VISUALIZACAO") {
      efeitos.push(() => aplicarMinhaVisualizacao(vm, row, revisoes.visualizacao));
    } else if(MODULO === "PEP" && CAMPO === "BOTOES_INCLUSAO_PEP" && revisoes.botoes === vm.layoutBotoesRevisao) {
      chamar("atendimentoInclusao", "aplicarConfiguracaoBotoes", row);
    } else if(MODULO === "AGENDA_RETORNO" && CAMPO === "TIPO_RETORNO" && TEXTO) { emitir("agendaRetornoDetalheTiposRetorno", row); }
    else if(MODULO === "AGENDA" && CAMPO === "FILTRA_PROCED_QTEM_PRC_SOLIC") { emitir("filtraProcedQtemPrcSolic", row); }
    else if(MODULO === "LAUDO" && CAMPO === "LAUDO_LIBERACAO_MODO") { emitir("laudoLiberadoModo", row); }
  }
  for(const row of snapshot.usuario) {
    if(row.CAMPO === "MARCA_OPCOES_REVISAR_ASSINAR" && row.CONTEUDO) { emitir("marcarOpcoesRevisarAssinar", row); }
    else if(row.CAMPO === "NAO_PERGUNTA_SAI_CONFECCAO_LAUDO" && row.CONTEUDO) { emitir("naoPerguntaSaiConfeccaoLaudo", row); }
  }
  Object.assign(vm, patch);
  efeitos.forEach(aplicar => aplicar());
}

export const contextoConfiguracoesProntuario = vm => JSON.stringify([vm.$route.fullPath, vm.idPaciente, vm.usuario, vm.idEmitenteML]);
const controladores = new WeakMap();
export function configuracoesProntuario(vm) {
  if(controladores.has(vm)) { return controladores.get(vm); }
  let atual, aplicada, encerrado = false;
  function invalidar() {
    atual?.controller.abort(); atual = null; aplicada = null;
    vm.isLoadingConfiguracoes = false; vm.configuracoesProntas = false; vm.erroConfiguracoes = "";
  }
  function carregar() {
    if(encerrado) { return Promise.resolve(false); }
    const contexto = contextoConfiguracoesProntuario(vm);
    if(atual?.contexto === contexto) { return atual.promise; }
    if(aplicada === contexto && vm.configuracoesProntas) { return Promise.resolve(true); }
    invalidar();
    const req = { contexto, controller: new AbortController(), revisoes: { visualizacao: contextoMinhaVisualizacao(vm), botoes: vm.layoutBotoesRevisao } };
    atual = req;
    const vigente = () => !encerrado && atual === req && contextoConfiguracoesProntuario(vm) === contexto;
    vm.isLoadingConfiguracoes = true;
    req.promise = Promise.resolve().then(async () => {
      try {
        if(!vigente()) { return false; }
        const pedidos = pedidosConfiguracoesProntuario(vm.usuario);
        const [master, usuario] = await Promise.all(["master", "usuario"].map(fonte => vm.consultarConfiguracoesProntuario({ fonte, configuracoes: pedidos, signal: req.controller.signal })));
        if(!vigente()) { return false; }
        const snapshot = prepararConfiguracoesProntuario(master, usuario, pedidos);
        aplicarConfiguracoesProntuario(vm, snapshot, req.revisoes);
        vm.configuracoesProntas = true; aplicada = contexto;
        return true;
      } catch(error) {
        req.controller.abort();
        if(vigente()) { vm.erroConfiguracoes = "Não foi possível carregar as configurações do prontuário. Tente novamente antes de iniciar ou salvar o atendimento."; }
        return false;
      } finally {
        if(atual === req) { atual = null; vm.isLoadingConfiguracoes = false; }
      }
    });
    return req.promise;
  }
  const controle = { carregar, invalidar, destruir() { invalidar(); encerrado = true; } };
  controladores.set(vm, controle);
  return controle;
}
